module.exports = __webpack_public_path__ + "static/img/sportGame2.83c2fc8.webp";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/sport/sportGame2.webp
// module id = B/q7
// module chunks = 3